import { useContext } from "react";
import AuthContext from "utils/context/auth-context";

function useAuth() {
  const auth = useContext(AuthContext);
  return auth;
}

export default useAuth;
